import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { epics as ForecastsEpics } from '../actions/Forecasts';
import { epics as HistoricalsEpics } from '../actions/Historicals';
import { reducer as forecastReducer } from '../reducers/Forecasts';
import { reducer as historicalReducer } from '../reducers/Historicals';
import { reducer as generalReducer } from '../reducers/General';
import { createEpicMiddleware } from 'redux-observable';
import { combineEpics } from 'redux-observable';
import logger from 'redux-logger';
import { createBrowserHistory } from 'history';

const epicMiddleware = createEpicMiddleware();

function configureStore(history, initialState) {
  const reducers = {
    forecasts: forecastReducer,
    historicals: historicalReducer,
    general: generalReducer
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer
  });

  const store =  createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware, logger, epicMiddleware), ...enhancers)
  );

  epicMiddleware.run(combineEpics(...ForecastsEpics, ...HistoricalsEpics));

  return store;
}

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
export const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
export const store = configureStore(history, initialState);
